import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
    
    console.error("%c CRITICAL ERROR: 'root' element not found! ", "background: red; color: white; font-size: 20px; font-weight: bold;");
} else {
    const root = ReactDOM.createRoot(rootElement);
    
    
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}


const setViewportHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

window.addEventListener('resize', setViewportHeight);
setViewportHeight();